import { HttpClient, HttpErrorResponse, HttpResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class SiteIncidentsService {


  constructor(private http: HttpClient) { }

  public getReportedEmergencyIncident(): Observable<any> {
    return this.http
      .get(environment.apiUrl + 'api/ext-incident/reported-emergency')
      .pipe(map((response: number) => response))
      .pipe(catchError(this.handleError));
  }

  public addIncident(incident) {
    return this.http.post(environment.apiUrl + 'api/ext-incident/' , incident)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public updateSiteIncident(incidentId: number, incident) {
    console.log("updating incodent");
    return this.http.put(environment.apiUrl + 'api/ext-incident/' + incidentId, incident)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getIncidentsBySite(pagination, sortproperty, sortdirection, siteId: number, fromDate?, toDate?, status?, ) {
    let params = new HttpParams();
    params = params.append('sort', sortproperty + ',' + sortdirection);
    params = params.append('page', String(pagination.page));
    params = params.append('size', String(pagination.size));
    if(status){
      params = params.append('status', status);
    }
    if(fromDate){
      params = params.append('fromDate', fromDate);
    }
    if(toDate){
      params = params.append('toDate', toDate);
    }

    return this.http.get(environment.apiUrl + `api/ext-incident/by-site/${siteId}`, { params, observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }


  // Handle Responses
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }
}
